export enum ChartVersionStatusEnum {
    none = 1,
    current,
    approved,
    archive,
    onApproval,
    cancelled,
}
